// extracted by mini-css-extract-plugin
module.exports = {"arrow-size":"7px","toggleButton":"Editor_toggleButton__3IEC0 shared_uiButton__2rrO2","toggleSideArrow":"Editor_toggleSideArrow__1OY0K","toggleArrow":"Editor_toggleArrow__3w5PL"};